import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Root from './pages/Root';
import Config from './components/Config';
import FlipOIDC from './components/FlipOIDC';
import HTMLCamera from './components/HTMLCamera';
import FlipThemes from './components/FlipThemes';

import Payslips from './pages/Payslips';
import EmployeeCard from './pages/EmployeeCard';
import FlipAI from './pages/FlipAI';
import Forms from './pages/Forms';
import Grilld from './pages/Grilld';
import Leave from './pages/Leave';
import OrgChart from './pages/OrgChart';
import Recognition from './pages/Recognition';
import Shifts from './pages/Shifts';
import TimeAttendance from './pages/TimeAttendance';
import BenJerrys from './pages/BenJerrys';
import DemoConfig from './components/DemoConfig';

import './styles/spacing.css';
import './styles/flip.css';
import './styles/app.css';
import 'react-toastify/dist/ReactToastify.css';

export default function App() {
  return (
    <HTMLCamera>
      <BrowserRouter>
        <Config>
          <FlipOIDC>
            <DemoConfig>
              <FlipThemes>
                <Routes>
                  <Route path="/employee-card/*" element={<EmployeeCard />} />
                  <Route path="/ai/*" element={<FlipAI />} />
                  <Route path="/forms/*" element={<Forms />} />
                  <Route path="/grilld/*" element={<Grilld />} />
                  <Route path="/leave/*" element={<Leave />} />
                  <Route path="/orgchart/*" element={<OrgChart />} />
                  <Route path="/payslips/*" element={<Payslips />} />
                  <Route path="/recognition/*" element={<Recognition />} />
                  <Route path="/shifts/*" element={<Shifts />} />
                  <Route path="/time-attendance/*" element={<TimeAttendance />} />
                  <Route path="/ben-jerrys/*" element={<BenJerrys />} />
                  <Route path="/" element={<Root />} />
                </Routes>
              </FlipThemes>
            </DemoConfig>
          </FlipOIDC>
        </Config>
      </BrowserRouter>
      <ToastContainer />
    </HTMLCamera>
  );
}
